import { create } from './requestAjax';

export const instance = create();
